import React from "react";
import style from "./referral.module.css";

const ReferralCode = () => {
  return (
    // {/* ------ Referral code ----------- */}
    <div className={style.ReferralCode}>
      <h3>Your Referral Code</h3>
      <div>
        <h4>&emsp;EDCH54</h4>
      </div>
    </div>
  );
};

export default ReferralCode;
